import type { AudienceFilters, AudienceSearchResultDto } from '@/types/audience'

interface AudienceCacheEntry {
    filters: AudienceFilters
    items: AudienceSearchResultDto[]
    timestamp: number
    scrollY?: number
}

// Simple in-memory cache keyed by company:workspace
const audienceCache = new Map<string, AudienceCacheEntry>()

function key(companyId: string, workspaceId: string) {
    return `${companyId}:${workspaceId}`
}

export function getAudienceCache(companyId: string, workspaceId: string): AudienceCacheEntry | undefined {
    return audienceCache.get(key(companyId, workspaceId))
}

export function setAudienceCache(companyId: string, workspaceId: string, entry: AudienceCacheEntry) {
    audienceCache.set(key(companyId, workspaceId), entry)
}

export function clearAudienceCache(companyId: string, workspaceId: string) {
    audienceCache.delete(key(companyId, workspaceId))
}

export type { AudienceCacheEntry }
